export default __webpack_public_path__ + "static/media/01-password-generator-main.aa25cbf8.png";